import React, { useState, useEffect } from 'react';
var styles = {
  "normalTheme": "_35Xnh"
};

function TextScrambler(props) {
  var _useState = useState(props.phrases[0]),
      message = _useState[0],
      setMessage = _useState[1];

  var _useState2 = useState(props.phrases[1]),
      nextMessage = _useState2[0],
      setNextMessage = _useState2[1];

  var _useState3 = useState(0),
      count = _useState3[0],
      setCount = _useState3[1];

  var _useState4 = useState(80),
      speed = _useState4[0],
      setSpeed = _useState4[1];

  var _useState5 = useState(1000),
      time = _useState5[0],
      setTime = _useState5[1];

  var _useState6 = useState(1000),
      pauseTime = _useState6[0],
      setPauseTime = _useState6[1];

  var _useState7 = useState([false, false, false]),
      steps = _useState7[0],
      setSteps = _useState7[1];

  var _useState8 = useState(),
      phrases = _useState8[0],
      setPhrases = _useState8[1];

  var _useState9 = useState(0),
      repetitions = _useState9[0],
      setRepetitions = _useState9[1];

  var _useState10 = useState(-1),
      maxReps = _useState10[0],
      setMaxReps = _useState10[1];

  var _useState11 = useState('!<>-_\\/[]{}—=+*^?#________'),
      chars = _useState11[0],
      setChars = _useState11[1];

  function swapLetters() {
    var _char = chars[Math.floor(Math.random() * chars.length)];

    while (true) {
      var index = Math.floor(Math.random() * message.length);

      if (!chars.includes(message[index])) {
        setMessage(message.substring(0, index) + _char + message.substring(index + 1));
        break;
      }
    }
  }

  function swapSymbols() {
    while (true) {
      var index = Math.floor(Math.random() * message.length);

      if (chars.includes(message[index])) {
        setMessage(message.substring(0, index) + nextMessage[index] + message.substring(index + 1));
        break;
      }
    }
  }

  function removeSymbols() {
    var index = Math.floor(Math.random() * message.length);
    setMessage(message.substring(0, index) + message.substring(index + 1));
  }

  function addSymbols() {
    var _char2 = chars[Math.floor(Math.random() * chars.length)];
    var index = Math.floor(Math.random() * message.length);

    if (index !== 0) {
      setMessage(message.substring(0, index) + _char2 + message.substring(index));
    } else {
      setMessage(_char2 + message.substring(0));
    }
  }

  function stepOne(item) {
    for (var i = 0; i < item.length; i++) {
      if (!chars.includes(item[i])) {
        swapLetters();
        return 1;
      }
    }

    return 0;
  }

  function stepThree(item) {
    for (var i = 0; i < item.length; i++) {
      if (chars.includes(item[i])) {
        swapSymbols();
        break;
      }
    }
  }

  function nextWord(index, word) {
    setRepetitions(repetitions + 1);
    setCount(index);
    setNextMessage(phrases[word]);
    setSteps([false, false, false]);
  }

  useEffect(function () {
    if (props.speed !== undefined) {
      setSpeed(props.speed);
    }

    if (props.pauseTime !== undefined) {
      setPauseTime(props.pauseTime);
    }

    if (props.chars !== undefined) {
      setChars(props.chars);
    }

    if (props.repetitions !== undefined) {
      setMaxReps(props.repetitions);
    }

    if (props.phrases !== undefined) {
      setPhrases(props.phrases);
    } else {
      return /*#__PURE__*/React.createElement("div", null, "phrases missing/incomplete/incorrect format");
    }

    var interval = setInterval(function () {
      setTime(speed);

      if (repetitions === maxReps) {
        return function () {
          return clearInterval(interval);
        };
      }

      if (message !== nextMessage) {
        if (!steps[0]) {
          if (stepOne(message) === 0) {
            setSteps([true, false, false]);
          }
        }

        if (steps[0] && !steps[1]) {
          if (message.length > nextMessage.length) {
            removeSymbols();
          }

          if (message.length < nextMessage.length) {
            addSymbols();
          }

          if (message.length === nextMessage.length) {
            setSteps([true, true, false]);
          }
        }

        if (steps[1] && !steps[2]) {
          stepThree(message);
        }
      } else {
        setTime(pauseTime);

        if (count === phrases.length - 2) {
          nextWord(phrases.length - 1, 0);
        }

        if (count === phrases.length - 1) {
          nextWord(0, 1);
        }

        if (count < phrases.length - 2) {
          nextWord(count + 1, count + 2);
        }
      }
    }, time);
    return function () {
      return clearInterval(interval);
    };
  });

  var JSXify = function JSXify(item) {
    var style;

    if (props.symbolColor !== undefined) {
      style = {
        color: props.symbolColor
      };
    } else {
      style = {
        color: "rgb(143, 143, 143)"
      };
    }

    if (message != null) {
      var jsx = [];

      for (var i = 0; i < item.length; i++) {
        if (chars.includes(item[i])) {
          jsx.push( /*#__PURE__*/React.createElement("span", {
            style: style
          }, item[i]));
        } else {
          jsx.push( /*#__PURE__*/React.createElement("span", null, item[i]));
        }
      }

      return jsx;
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.normalTheme
  }, JSXify(message));
}

export default TextScrambler;